import { compose, hoistStatics, withHandlers, lifecycle, withProps, defaultProps, withState } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Item from './Item';
import fh from '../../../helpers/form.helper';
import ModelService from '../../../services/font.service';
import CardLoading from '../../../components/CardLoading';
import WithLoading from '../../../components/WithLoading';
import { uploadSelectors, uploadActions } from '../../../reducers/upload';
import CompanyService from "../../../services/company.service";

const imageSelector = uploadSelectors.getTempFile('image');

const mapStateToProps = state => ({
  image: imageSelector(state),
});

const mapDispatchToProps = {
  removeTempFile: uploadActions.removeTempFile,
};

const defaultFormData = {
  name: '',
  status: 1,
  is_default: 0,
};

const onChangeCompanyInput = props => async input => {
  await props.setCompanyInput(input);
};

const searchCompany = props => async () => {
  return await CompanyService.getAll({ title: props.companyInput })
};

const applyModel = fh.createApplyModel(defaultFormData);

const onSubmit = props => redirect => async (event) => {
  const { image, isNewModel, history, formData, t } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update({
    ...formData,
    image: image && image.id ? image.id : '',
  });
  if (!errors) {
    if (redirect) return history.push(ModelService.baseRoute);
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    props.removeTempFile('image');
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('countries', 'setCountries', []),
  withState('searchCity','setSearchCity', ''),
  withState('companyInput', 'setCompanyInput', ''),
  defaultProps({
    getImage: ModelService.getImage,
    tab: () => '<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>',
  }),
  ...fh.defaultRecompose(defaultFormData),
  lifecycle({
    async componentDidMount() {
      await fh.initModelData(this.props, applyModel, ModelService);
      window.recaptchaOptions = {
        lang: this.props.i18n.language,
      };
    },
  }),
  withProps(props => ({
    title: props.t('Font') + fh.getTitleEnd(props),
    imageSrc: props.image && props.image.url
      ? props.image.url : ModelService.getImage(props.formData.image, 150, 150),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
    onChangeCompanyInput,
    searchCompany,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Item, CardLoading)));



// WEBPACK FOOTER //
// ./src/views/fonts/item/index.js